import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setAfterLoginAction } from '@services/user/actions';
import useGoLogin from 'hooks/useGoLogin';
import { LOGIN_REDIRECT } from '@services/user/afterLoginTypes';

const PrivateRoute = ({ component: Component, ...props }) => {
	const { LoginRedirect } = useGoLogin(false);

	const dispatch = useDispatch();
	const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

	if (isLoggedIn) {
		return <Component {...props} />;
	}

	dispatch(setAfterLoginAction(LOGIN_REDIRECT, '', props.location.pathname));

	return <LoginRedirect />;
};

export default PrivateRoute;
